<template>
  <b-modal id="modal-privacy" hide-footer scrollable size="xl">
        <template #modal-title>
          <h3 class="text-success"><b>Privacy Policy</b></h3>
        </template>
        <h5 align="right">
          <b>Privacy Policy</b><br /><br />
          Date of last update: July 1, 2020
        </h5>
        <br />
        <h5 style="text-indent: 2.5em">
          The following privacy policy (“Privacy Policy”) describes how
          Sentenance and its affiliates (collectively, “Sentenance”, “we” or
          “us”) collects, uses and discloses information you provide to us or
          which we otherwise collect in providing products or services to you
          (“User Information”).
        </h5>
        <h5 class="mt-1" style="text-indent: 2.5em">
          Use of our products and services (collectively “Sentenance Products”)
          is subject to the terms of our Terms of Use (the “Terms”) and any
          other written agreement we enter into with you. The provisions of this
          Privacy Policy are incorporated into each such agreement as if fully
          set forth therein.
        </h5>
        <br />
        <br />
        <h4><b>Online or Offline Interactions with Sentenance</b></h4>
        <br />
        <h5 style="text-indent: 2.5em">
          When you interact online or offline with us, we may receive User
          Information from you, including Personal Data. This may happen when
          you a) visit our websites, b) access the Sentenance Platform, b)
          download materials from our websites, c) provide account information
          through our websites, or d) attend events we host or sponsor. We also
          may collect information about you from sources such as public
          databases, marketing partners, social media sources, event hosts and
          partners when you interact with them. We or others acting on our
          behalf may collect such information, including information relating to
          you (“Personal Data”), through such interactions. Categories of
          Personal Data we may collect include your name, email address,
          physical address, your employer, your job title, payment details for
          payment for our services, your phone number, your IP address, and your
          username. Personal Data may be collected by us when you enter
          Personal Data on our website forms. IP addresses are collected by us
          on an automated basis when you use our websites. We may be able to
          determine your location from your IP address. For additional
          information on our use of cookies and similar technologies, please
          review our Cookies Policy at www.Sentenance.com
        </h5>
        <h5 class="mt-1" style="text-indent: 2.5em">
          We use the information we collect from such interactions to provide
          Sentenance Products to you in accordance with our Terms, to satisfy
          legal requirements that apply to us, or to meet our legitimate
          business interests, as further described below. In particular, we use
          User Information to:
        </h5>
        <h5 class="mt-3">
          <ul class="ml-5">
            <li class="mt-1">Deliver Sentenance Products to you</li>
            <li class="mt-1">Respond to requests for information from you</li>
            <li class="mt-1">
              Develop, maintain and improve Sentenance Products we provide to
              you, including website services
            </li>
            <li class="mt-1">
              Provide you with an account for access to our websites and
              Sentenance Products, and manage your account
            </li>
            <li class="mt-1">Provide administrative information to you</li>
            <li class="mt-1">
              Deliver marketing-related communications to you
            </li>
            <li class="mt-1">
              Invite you to participate in surveys or related studies
            </li>
            <li class="mt-1">
              Diagnose, analyze or monitor security, security threats or
              technical issues or problems relating to our websites or
              Sentenance Products
            </li>
            <li class="mt-1">
              Comply with applicable laws, rules, regulations, legal or
              regulatory proceedings or to protect our legal rights
            </li>
            <li class="mt-1">
              Engage in other courses of action disclosed to you in connection
              with use of Sentenance Products from time to time.
            </li>
          </ul>
        </h5>
        <h5 class="mt-1" style="text-indent: 2.5em">
          If we process your Personal Data for purposes other than those set
          forth above, we will inform you prior to such processing.
        </h5>

        <br /><br />
        <h4><b>Opting Out of Marketing Communications</b></h4>
        <br />
        <h5 style="text-indent: 2.5em">
          If you wish not to receive marketing-related emails from us, please
          email us to that effect at <a href=""> info@Sentenance.com</a>
        </h5>
        <br /><br />
        <h4><b>Operational Data</b></h4>
        <br />
        <h5 style="text-indent: 2.5em">
          Operational Data is information generated by your use of Sentenance
          Products such as page views, interactions, number of active and
          licensed users, errors, number of searches, source types and format
          (e.g., xml, json, csv, etc.), app workflows, etc. We use Operational
          Data to provide and enhance Sentenance Products. For example, we may
          use this data to analyze, monitor and troubleshoot operational issues;
          analyze and monitor behavior across deployments; perform data
          analysis; provide recommendations to help optimize usage; monitor and
          understand performance issues; improve the operation of Sentenance
          Products; personalize your experience; and build new functionality and
          features.
        </h5>
        <h5 class="mt-1" style="text-indent: 2.5em">
          Collection Practices in Connection with Administrative and Operational
          Activities
        </h5>

        <h5 class="mt-1" style="text-indent: 2.5em">
          Sentenance also collects your Personal Data to carry out various
          obligations in connection with provision of Sentenance Products to
          you, such as entering your name, email address, physical address, your
          employer, your job title, your phone number, and your username into
          our customer database systems and manage your account and maintaining
          our billing and payments, customer services and support services
          activities and updating software.
        </h5>

        <br /><br />
        <h4><b>Sharing of User Information</b></h4>
        <br />
        <h5 style="text-indent: 2.5em">
          We may share User Information with third parties as follows:
        </h5>
        <h5 class="mt-3">
          <ul class="ml-5">
            <li class="mt-1">
              We may disclose User Information to our affiliates who are subject
              to this Privacy Policy for the purpose of helping them deliver or
              administer Sentenance Products.
            </li>
            <li class="mt-1">
              We may disclose User Information to our service providers (e.g.,
              infrastructure as a service, professional/customer/support
              services), pursuant to written agreements with confidentiality
              obligations.
            </li>
            <li class="mt-1">
              We may disclose User Information to our business partners or event
              sponsors pursuant to written agreements with confidentiality
              obligations.
            </li>
            <li class="mt-1">
              We may disclose User Information as we deem necessary or
              appropriate under applicable laws, rules or regulations (including
              laws, rules or regulations outside your country of residence), in
              order to comply with laws, rules or regulations, to respond to
              requests from any governmental or public authority (including
              outside your country of residence), to enforce provisions of any
              agreement between you and us, to protect our operations, or to
              protect our rights, privacy, safety or property and/or that of you
              or others.
            </li>
            <li class="mt-1">
              We may disclose User Information in connection with a proposed or
              actual merger, sale, joint venture, reorganization, assignment,
              transfer or other disposition or similar corporate transaction
              relating to all or any portion of our business, assets or capital
              stock.
            </li>
          </ul>
        </h5>
        <br /><br />
        <h4><b>How We Secure User Information</b></h4>
        <br />
        <h5 style="text-indent: 2.5em">
          We take reasonable technical and organizational measures to safeguard
          Personal Data against theft, loss and unauthorized access, disclosure,
          misuse, destruction or alteration. Nonetheless, no data transmission,
          software, or storage system can be guaranteed to be 100% secure and we
          cannot guarantee absolute security. In addition, we are not
          responsible for the security of data or information you transmit to us
          over networks that are not under our control. If you have reason to
          believe that your interaction with us is no longer secure, please
          notify us immediately in accordance with the “Questions and Comments”
          section below. If we determine a breach of our systems has occurred,
          we may notify you or others consistent with applicable laws and/or as
          agreed in our agreements with you. We may communicate with you
          electronically regarding security, privacy, and administrative issues
          relating to your use of Sentenance Products and the information you
          provide to us.
        </h5>
        <br /><br />
        <h4><b>Retention; Transfers</b></h4>
        <br />
        <h5 style="text-indent: 2.5em">
          We retain User Information for the period we determine is necessary to
          carry out the purposes set forth in this Privacy Policy, except where
          a longer retention period may be required or not prohibited under
          applicable law. We retain contract information for the duration of
          your contract with us and afterward as required or permitted under
          applicable law. Your Personal Data may be stored and/or processed in
          any country in which we have facilities or in which we engage service
          providers which are located outside of your country of residence.
          Different data protection rules from those applicable in your country
          of residence may therefore apply.
        </h5>
        <br /><br />
        <h4><b>Third Parties</b></h4>
        <br />
        <h5 style="text-indent: 2.5em">
          Sentenance Products may include links to or facilitate access to other
          websites or online services. This Privacy Policy does not address, and
          we are not responsible for, the privacy, information, or practices of
          other parties, including any app developer, app provider, social media
          platform provider, operating system provider, wireless service
          provider, or device manufacturer. The inclusion of a link in
          Sentenance Products does not imply endorsement of the linked site or
          service by us. We encourage you to review the privacy policies and
          learn about the privacy practices of those companies whose websites
          you choose to visit.
        </h5>
        <br /><br />
        <h4><b>Changes</b></h4>
        <br />
        <h5 style="text-indent: 2.5em">
          We may modify this Privacy Policy from time to time and our updates
          will be posted here.
        </h5>
        <br /><br />
        <h4><b>Questions or Comments</b></h4>
        <br />
        <h5 style="text-indent: 2.5em">
          If you have questions, comments or concerns regarding this Privacy
          Policy, you can contact us any time at
          <a href>info@Sentenance.com </a> .
        </h5>
        <br /><br />
      </b-modal>
</template>

<script>
export default {

}
</script>

<style>

</style>